import { defineComponent, computed, h } from 'vue';

var vSwitch = defineComponent({
    props: {
        "case": {
            type: [String, Number]
        }
    },
    // () => h(...)
    setup: function (props, _a) {
        var slots = _a.slots;
        return function () { return computed(function () {
            if (props["case"] && slots[props["case"]]) {
                return h(slots[props["case"]]);
            }
            if (slots["default"]) {
                return h(slots["default"]);
            }
            return h('div');
        }).value; };
    }
});

export default vSwitch;
